<template>
  <ul>
    <li style="list-style-type:none;" v-for="listitem in this.data" :key="listitem">{{ listitem }}</li>
  </ul>
</template>

<script>
export default {
  name: "SimpleListComponent",
  components: {},
  props: {},
  mounted() {
    this.data = this.params.data[this.params.list].split(",");
  },
  data: () => ({
    data : []
  }),
  methods: {},
};
</script>
